// DO NOT REMOVE `configBehaviorIgnore: true` - this is a test file
const {
  evaluateSource
} = require(/* configBehaviorIgnore: true */'../lib/evaluateSource');
const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const {
    selection = {}
  } = transientContext;
  const [firstKey] = Object.keys(selection);
  const {
    title: message = 'No option'
  } = selection[firstKey] || {};
  const alertSource = {
    type: 'alertBehavior',
    title: 'Config Options',
    message,
    options: [{
      title: 'OK'
    }]
  };
  const result = await evaluateSource(alertSource, content, parentContentPath, transientContext, nativeFunctions);
  return result;
};
module.exports = {
  evaluate
};